
import React from "react";
import { User } from "@/context/AuthContext";
interface NotificationDetailHeaderProps {
  isArchived: boolean;
  currentUser?: User | null;
}

const NotificationDetailHeader = ({
  isArchived,
  currentUser,
}: NotificationDetailHeaderProps) => {
  return (
    <div className="flex flex-col gap-3 sm:gap-4">
      <div className="text-lg sm:text-xl font-semibold">
        {isArchived ? "Gearchiveerde Melding" : "Melding Details"}
        {currentUser && (
          <div className="text-sm font-normal text-muted-foreground">
            Ingelogd als: {currentUser.name}
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationDetailHeader;
